"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCompiler = exports.getPlatformScryptc = void 0;
var path_1 = require("path");
var minimist = require("minimist");
var fs_1 = require("fs");
var compareVersions = require("compare-versions");
var child_process_1 = require("child_process");
var chalk_1 = require("chalk");
var os = require("os");
var process_1 = require("process");
function getPlatformScryptc() {
    switch (os.platform()) {
        case 'win32':
            return 'compiler/scryptc/win32/scryptc.exe';
        case 'linux':
            return 'compiler/scryptc/linux/scryptc';
        case 'darwin':
            return 'compiler/scryptc/mac/scryptc';
        default:
            throw "sCrypt doesn't support " + os.platform();
    }
}
exports.getPlatformScryptc = getPlatformScryptc;
function find_compiler_vscode() {
    var homedir = os.homedir();
    var extensionPath = path_1.join(homedir, '.vscode/extensions');
    if (!fs_1.existsSync(extensionPath)) {
        return undefined;
    }
    var sCryptPrefix = 'bsv-scrypt.scrypt-';
    var versions = fs_1.readdirSync(extensionPath).reduce(function (filtered, item) {
        if (item.indexOf(sCryptPrefix) > -1) {
            var version = item.substring(sCryptPrefix.length);
            if (compareVersions.validate(version)) {
                filtered.push(version);
            }
        }
        return filtered;
    }, []);
    // compareVersions is ascending, so reverse.
    versions = versions.sort(compareVersions).reverse();
    var sCryptExtensionDirName = sCryptPrefix + versions[0];
    var scryptc = path_1.join(extensionPath, sCryptExtensionDirName, getPlatformScryptc());
    return fs_1.existsSync(scryptc) ? scryptc : undefined;
}
function find_compiler_local(directory) {
    if (directory === void 0) { directory = __dirname; }
    var compiler = path_1.resolve(directory, 'compiler');
    if (fs_1.existsSync(compiler) && fs_1.statSync(compiler).isDirectory()) {
        var scryptc = path_1.join(compiler, '..', getPlatformScryptc());
        return fs_1.existsSync(scryptc) ? scryptc : undefined;
    }
    var parent = path_1.resolve(directory, '..');
    if (parent === directory) {
        return undefined;
    }
    return find_compiler_local(parent);
}
function find_compiler_PATH() {
    var isWin = os.platform().indexOf('win') > -1;
    var where = isWin ? 'where' : 'which';
    try {
        var scryptc = child_process_1.execSync(where + " scryptc", { stdio: [] }).toString();
        return scryptc.replace(/\r\n/g, '');
    }
    catch (error) {
        return undefined;
    }
}
// Searches known directories for a specific platform and returns Path object of the sCrypt compiler binary if found.
function findCompiler() {
    var argv = minimist(process.argv.slice(2));
    var scryptc = argv.scryptc;
    if (scryptc && scryptc.startsWith('"') && scryptc.endsWith('"')) {
        scryptc = scryptc.substring(1, scryptc.length - 1);
    }
    // If a special compiler is specified on the command line, the specified compiler is used
    if (scryptc && fs_1.existsSync(scryptc)) {
        return scryptc;
    }
    scryptc = find_compiler_local();
    if (scryptc && fs_1.existsSync(scryptc)) {
        return scryptc;
    }
    scryptc = find_compiler_PATH();
    if (scryptc && fs_1.existsSync(scryptc)) {
        return scryptc;
    }
    scryptc = find_compiler_vscode();
    if (scryptc && fs_1.existsSync(scryptc)) {
        return scryptc;
    }
    console.info(chalk_1.default.red.bold('**ERROR**') + " " + chalk_1.default.red('No sCrypt compiler found.') + "\n\n  ");
    console.info("" + chalk_1.default.green.bold('You can install the compiler in the following ways: \n'));
    console.info("" + chalk_1.default.grey('•'), "Run " + chalk_1.default.yellow.bold('npx scryptlib download') + " to download the compiler binary.");
    console.info("" + chalk_1.default.grey('•'), "Install " + chalk_1.default.bold('sCrypt IDE') + " at vscode extension marketplace: " + chalk_1.default.blue.bold('https://marketplace.visualstudio.com/items?itemName=bsv-scrypt.sCrypt'));
    process_1.exit(-1);
}
exports.findCompiler = findCompiler;
//# sourceMappingURL=findCompiler.js.map